import React from 'react';
import { Metric as MetricType } from '@hud/portal-dtos/webapp-common.dto';
import styled from 'styled-components';
import { TrendVariants } from '../Trend/Trend';
import {
  formatBigNumbers,
  formatDuration,
  formatNumber,
  formatPercentage,
  formatPrice,
} from '../utils';
import MetricTrend from './MetricTrend';

export const MetricFormatters = {
  currency: formatPrice,
  percent: formatPercentage,
  duration: formatDuration,
  abbreviated: formatAbbreviated,
  undefined: formatNumber,
};

function _formatMetric(
  value: number,
  showAsEstimated: boolean,
  unit?: keyof typeof MetricFormatters | undefined,
) {
  const formatterFunc = MetricFormatters[unit || 'undefined'] || formatNumber;
  return showAsEstimated ? `~${formatterFunc(value)}` : formatterFunc(value);
}

export interface MetricProps {
  metric?: MetricType;
  unit?: keyof typeof MetricFormatters;
  showAsEstimated?: boolean;

  showTrend?: boolean;
  trendVariant?: TrendVariants;
  trendTooltip?: string;
}

export default function Metric({
  metric,
  unit,
  showAsEstimated,
  showTrend,
  trendVariant,
  trendTooltip,
}: MetricProps) {
  if (!metric) {
    return '-';
  }

  const displayValue = _formatMetric(metric.value, !!showAsEstimated, unit);

  return (
    <Container>
      {displayValue}
      {showTrend && <MetricTrend metric={metric} variant={trendVariant} tooltip={trendTooltip} />}
    </Container>
  );
}

export const Container = styled.span`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: 7px;
`;

export function formatAbbreviated(value: number) {
  return formatBigNumbers(value);
}